import React from 'react'
import Select from "react-select";
import makeAnimated from 'react-select/animated';


const animatedComponents = makeAnimated();



export const SelectElement = ({ options, id, name, isMulti, closeOnMenuSelect, onChange, className, seleccionado, isClearable, onfocus, fontSize = '1em' }) => {

    // const [optionSelected, setSelectedOptions] = useState('');
    let e = ''


    if (isClearable === undefined) isClearable = true;

    if (options !== "") {
        e = (options.map(item => item.value).indexOf(seleccionado))
    }

    return (
        <Select
            options={options}
            isLoading={!options}
            components={animatedComponents}
            isSearchable={true}
            isClearable={isClearable}
            getOptionValue={(option) => `${option['label']}`}
            closeMenuOnSelect={closeOnMenuSelect}
            defaultValue={options[e]}
            id={id}
            name={name}
            isMulti={isMulti}
            onMenuClose={true}
            placeholder="Seleccione"
            noOptionsMessage={() => "No hay resultados"}
            // onChange = {onChange}
            onChange={(selectedOption) =>
                onChange({
                    target: {
                        id: id || name,
                        value: selectedOption?.value || ''
                    }
                })
            }
            onFocus={onfocus}
            classNames={{

                control: (state) =>
                    state.isFocused ? `${className}` : `${className}`
            }}
            menuPortalTarget={document.body}
            menuPosition="fixed" // posición fija respecto al viewport
            styles={{
                control: (base) => ({
                    ...base,
                    fontSize: fontSize,
                    minHeight: 'auto'
                }),
                singleValue: (base) => ({
                    ...base,
                    fontSize: fontSize
                }),
                input: (base) => ({
                    ...base,
                    fontSize: fontSize
                }),
                placeholder: (base) => ({
                    ...base,
                    fontSize: fontSize
                }),
                option: (base) => ({
                    ...base,
                    fontSize: fontSize,
                    padding: '10px 15px'
                }),
                menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999
                })
            }}

        />
    )
}
